module.exports = __webpack_public_path__ + "static/media/pod-offline.13859030.svg";